import React, { useEffect, useMemo, useState } from "react";
import { useTable } from "react-table";
import MultiSelectReusableField from "../ReactTable/MultiSelectReusableField";
import { mutateData } from "../Service/graphQlService";
import { MERGE_DELETE_DUPLICATE_CONTACT } from "../Graphql/ContactsMutations/allContactsMutation";
import ConfirmationSaveDialog from "./ConfirmationSaveDialog";
import { MERGE_DELETE_DUPLICATE_COMPANIES } from "../Graphql/CompanysMutations/allCompanysMutation";
import { Alert } from "@mui/material";
import ReusableSpinner from '../ReactTable/ReusableSpinner';

const SelectedMergingTable = React.memo(({ selectedCells, setSelectedCells, debouncedSearchTerm ,selectedCategory,capitalizedModuleName,setSavedToastMessage,setApiErrorMessage,savedToastMessage,apiErrorMessage,duplicateErrorMessage,setDuplicateErrorMessage,memoizedColumns}) => {
  const options = capitalizedModuleName === "Contacts" ?  ["Investor","Agent","Lender","Tenant", "Vendor"] : ["Company"]; //done changes to match the type
  const [errorfield, setErrorField] = useState("");
  const [SelectedTypes, setSelectedType] = useState([]);
  const [confirmSave,setConfirmSave]= useState(false)
  const [isCrm,setIsCrm] = useState(false)
useEffect(() => {
  const isMergeArray = (selectedCells && selectedCells.isMerge) ? selectedCells.isMerge : [];

  const mergedTypes = isMergeArray
    .map(function(item) {
      if (item && typeof item.type === "string") {
        const lowerType = item.type.toLowerCase();
       if (lowerType === "team" || lowerType === "buyer" || lowerType === "seller") return null;  // skip skip "Team/buyer/seller"
        return lowerType === "firm" ? "Company" : item.type;
      }
      return null;
    })
    .filter(Boolean); // removes null/undefined and "Team"

  setSelectedType([...new Set(mergedTypes)]);
}, [selectedCells]);

const [isLoading, setIsLoading] = useState(false);
  const columnNames = useMemo(() => {  //render column name intialy type will be default after that checked cell will be populated
    const dynamicallyIdColumn = capitalizedModuleName === "Contacts" ? "Contact id" : "Company id";
const columnsSet = new Set(["type", dynamicallyIdColumn]);
  
    (selectedCells.selectedData || []).forEach((cell) => {
      if (cell && cell.columnId) {
        columnsSet.add(cell.columnId);
      }
    });
  
    return Array.from(columnsSet);
  }, [selectedCells]);

  // Generate columns dynamically
  const columns = useMemo(
    () =>
      columnNames.map((col) => ({
        Header: col.replace("_", " ").toUpperCase(),
        accessor: col,
      })),
    [columnNames]
  );
  // // Ensure selectedCells data is always assigned to rowId "0"
  // const data = useMemo(() => {
  //   const singleRowData = {type: [] };

  //   (selectedCells.selectedData || []).forEach(({ columnId, type, value ,parent_firm}) => {
  //     singleRowData[columnId] = value;
  //     singleRowData.type = type || [];
      
  //   });

  //   return [singleRowData];
  // }, [selectedCells]);
function getMissingFieldsByType(memoizedColumns) {
  const selectedData = selectedCells && selectedCells.selectedData ? selectedCells.selectedData : [];
  const isMerge = selectedCells && selectedCells.isMerge ? selectedCells.isMerge : [];

  const excludedFields = ["select for merge", "contact id", "company id", "first name", "last name"];
  const selectedFieldsByType = {};

  const normalizeType = (t) => (t || "").toLowerCase().replace(/s$/, ""); // "Investors" → "investor"

  // Step 1: Group selected fields by type
  for (let i = 0; i < selectedData.length; i++) {
    const item = selectedData[i];
    if (!item || !item.type || !item.columnId) continue;

    const rawType = item.type; // keep actual key for lookup in memoizedColumns
    const normalizedType = normalizeType(item.type);
    const column = item.columnId.trim().toLowerCase();

    if (!selectedFieldsByType[normalizedType]) {
      selectedFieldsByType[normalizedType] = new Set();
    }

    selectedFieldsByType[normalizedType].add(column);
  }


  // Step 2: Gather all raw (non-normalized) types from isMerge
  const typesInMerge = new Set();
  for (let i = 0; i < isMerge.length; i++) {
    const item = isMerge[i];
    if (item && item.type) {
      typesInMerge.add(item.type); // use original casing/plural
    }
  }


  const missingFieldsByType = {};

  // Step 3: For each real type in isMerge, map to normalized version for selectedData match
  typesInMerge.forEach(function (realType) {
    const normalizedType = normalizeType(realType);
    const selectedFieldsSet = selectedFieldsByType[normalizedType];
    const selectedFields = selectedFieldsSet ? Array.from(selectedFieldsSet) : [];

   let headersForType = memoizedColumns[realType];

if (!headersForType) {
  // Try plural form fallback (e.g. Investor → Investors)
  const pluralType = realType.endsWith("s") ? realType : realType + "s";
  headersForType = memoizedColumns[pluralType];
}

    if (!Array.isArray(headersForType)) {
      return;
    }

    const expectedFields = headersForType
      .map(function (col) {
        if (col && typeof col.Header === "string") {
          return col.Header.trim().toLowerCase();
        }
        return null;
      })
      .filter(Boolean)
      .filter(function (field) {
        return !excludedFields.includes(field);
      });

    const missingFields = expectedFields.filter(function (field) {
      return !selectedFields.includes(field);
    });

    if (missingFields.length > 0) {
      missingFieldsByType[realType] = missingFields;
    }
  });

  return missingFieldsByType;
}

function getCommonMissingFieldsMessage(missingFieldsByType) {
  if (!missingFieldsByType || typeof missingFieldsByType !== "object") return "";

  // let message = "You're missing the following required fields:\n";
  let message = ""

  // 🟡 Desired order
  const preferredOrder = ["Investor", "Investors", "Agent", "Lender", "Tenant", "Vendor"];

  // 🟢 Sort keys based on preferredOrder
  const sortedEntries = Object.entries(missingFieldsByType).sort(([typeA], [typeB]) => {
    const indexA = preferredOrder.indexOf(typeA);
    const indexB = preferredOrder.indexOf(typeB);
    return (indexA === -1 ? 999 : indexA) - (indexB === -1 ? 999 : indexB);
  });

  // 📝 Build message
  for (const [type, fields] of sortedEntries) {
    if (!Array.isArray(fields) || fields.length === 0) continue;

    const formattedFields = fields.map((field) =>
      field
        .split(" ")
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(" ")
    );
    const displayType = type === "Firm" ? "Company" : type;

    message += `\n• ${displayType}: ${formattedFields.join(", ")}`;
  }

  return message.trim();
}



  const missingFieldsByType = getMissingFieldsByType(memoizedColumns);
 const missingFieldsMessage = getCommonMissingFieldsMessage(missingFieldsByType);
  const data = useMemo(() => {
     const dynamicallyIdColumn = capitalizedModuleName === "Contacts" ? "Contact id" : "Company id";
    const singleRowData = { type: [] , [dynamicallyIdColumn] : ""};
     
    (selectedCells.selectedData || []).forEach(({ columnId, type, value, parent_firm,firm_id }) => {
      singleRowData[columnId] = value;
      singleRowData.type = type || [];

     const selectedData =
       selectedCells && selectedCells.isMerge
         ? selectedCells.isMerge
         : [];

     const ids = selectedData
       .map(function (item) {
         return item.contact_id != null ? item.contact_id : item.company_id;
       })
       .filter(function (id) {
         return id != null;
       })
       .map(function (id) {
         return Number(id);
       });

const smallestId = ids.length > 0 ? Math.min.apply(null, ids) : null;
     singleRowData[dynamicallyIdColumn] = smallestId;
      if (parent_firm && columnId === "parent company") {
        singleRowData.parent_firm_id = parent_firm;
      }
      if(firm_id && columnId === "firm"){
        singleRowData.firm_id = firm_id
      }
      const selectedList = selectedCells.selectedData || [];
      const matchedRow = selectedList.find(function (item) {
        return (
          (item.contact_id && item.contact_id === singleRowData["contact id"]) ||
          (item.company_id && item.company_id === singleRowData["company id"])
        );
      });
      
      if (matchedRow && matchedRow.arcimedes_row_id) {
        singleRowData.arcimedes_row_id = matchedRow.arcimedes_row_id;
      }
    });
    return [singleRowData];
  }, [selectedCells]);

  // Handle dropdown change
  const handleTypeChange = (val) => { //selected type field handle change if user select other types
    setSelectedType((prevSelectedTypes) => {
      const newValues = Array.isArray(val) ? val : [val]; // Ensure `val` is always an array
  
      // Return only the values that are still selected
      return prevSelectedTypes.filter((type) => newValues.includes(type)).concat(
        newValues.filter((type) => !prevSelectedTypes.includes(type))
      );
    });
  };
  
  function extractData(input, data, selectedTypes) { //extracting data for payload 
    // Function to remove __typename from objects in an array
    const cleanArray = (arr) => {
        if (!Array.isArray(arr)) return [];
        return arr.map(({ __typename,type,firm,firm_id,...rest }) => rest);
    };
 

    // Extract and clean isDeleted and isMerge from the input object
    const result = {
        isDeleted: cleanArray(input.isDeleted),
        isMerge: cleanArray(input.isMerge)
    };
    // Process data array
    const processedData = data.map(item => {
      const { type, __typename, ...rest } = item; // Remove 'type' and '__typename' keys
      
      if(capitalizedModuleName === "Contacts"){
            const roleMap = {
              Agent: "y",
              "AthCap - Agent": "h",
              "AthCap - Employee": "e",
              Employee: "n",
              Intern: "i",
            };
            const typeMap = {
              "Team-Members": "Team",
              "Investors": "Investor"
            };
            const updatedSelectedTypes = selectedTypes.map(type => typeMap[type] || type);
            const transformedData = {
              contact_id : rest["Contact id"] ? rest["Contact id"] : null,
              first_name: rest["first name"] ? rest["first name"] : null,
              last_name: rest["last name"] ? rest["last name"] : null,
              email: rest.email ? rest.email : null,
              phone: rest.phone ? rest.phone :  rest["work phone"] ? rest["work phone"] :  null,
              cell_phone: rest["cell phone"] ? rest["cell phone"] : null,
              firm: rest.firm ? rest.firm_id : null,
              is_agent : rest.role && roleMap.hasOwnProperty(rest.role) ? roleMap[rest.role] : null,
              starting_date : rest["start date"] ? rest["start date"] : null,
              yrs_at_strive: rest["years at strive"] ? rest["years at strive"] : null,
              birth_date:rest["birth date"] ? rest["birth date"] : null,
              on_phones: rest["on phones"] ? rest["on phones"] : null,
              // in_pool:rest["in pools"] ? rest["in pools"] : null,
              first_listing:rest["1st listing"] ? rest["1st listing"] : null,
              first_closing:rest["1st closing"] ?rest["1st closing"] : null,
              name:rest["lender name"] ? rest["lender name"] : null,
              contact_phone:rest["phone #"] ? rest["phone #"] : null,
              contact_email:rest.email ? rest.email : null,
              status: rest.status ? rest.status : null,
              category:rest.category ? rest.category : null,
              type:rest["investor type"] ? rest["investor type"] : null,
              single_tenant_subcategory :rest.subcategory ? rest.subcategory : null,
              multi_tenant_subcategory :rest.subcategory ? rest.subcategory : null,
              market:rest.market ? rest.market : null,
              price_min:rest["price min"] ? Number(rest["price min"].replace(/[$,]/g, "").trim()) : null,
              price_max:rest["price max"] ? Number(rest["price max"].replace(/[$,]/g, "").trim()) : null,
              cap_rate_min:rest["cap rate min"] ? Number(rest["cap rate min"].replace("%", "").trim()) : null,
              cap_rate_max:rest["cap rate max"] ? Number(rest["cap rate max"].replace("%", "").trim()) : null,
              company_name:rest["company name"] ? rest["company name"] : null,
              strive_agent_last_name:rest.agent ? rest.agent : null,
              company_address:rest["company address"] ? rest["company address"] : null,
              company_city : rest.city ? rest.city : null,
              profile:rest.profile ? rest.profile : null,
              address: rest.address ? rest.address : null,
              city: rest.city ? rest.city : null,
              state: rest.state ? rest.state : null,
              zip: rest.zip ? rest.zip : null,
              arcimedes_row_id : rest.arcimedes_row_id ? rest.arcimedes_row_id : null
                };
            return { ...transformedData, contact_type: updatedSelectedTypes };
          }
          else if(capitalizedModuleName === "Company"){
            const transformedData = {
              address: rest.address ? rest.address : null,
              city: rest.city ? rest.city : null,
              company_id : rest["Company id"] ?  rest["Company id"] : null,
              parent_firm : rest["parent company"]  ? rest.parent_firm_id : null,
              name:rest.company ? rest.company : null,
              phone: rest.phone ? rest.phone :  null,
              state: rest.state ? rest.state : null,
              website:rest.website ? rest.website : null,
              zip: rest.zip ? Number(rest.zip) : null,
              arcimedes_row_id : rest.arcimedes_row_id ? rest.arcimedes_row_id : null
                };
            return { ...transformedData, company_type: selectedTypes };
          }
  });
    
    return { ...result, selectedData: processedData };
}

    // setSelectedCells((prev) => prev.map((cell) => ({ ...cell, type: selectedTypes })));

    const handleSubmit = async () => {   //handleing the submit while user click on submit
      setIsLoading(true);
      const extractedData = extractData(selectedCells, data, SelectedTypes);
      if(capitalizedModuleName === "Contacts"){
      try {
          const res = await mutateData(MERGE_DELETE_DUPLICATE_CONTACT, { input: extractedData });
           
          if(res.data.mergeAndDeleteDuplicate.success){
            setDuplicateErrorMessage(null)
            setSavedToastMessage(true)
          }
          else if(res.data.mergeAndDeleteDuplicate.error){
            setDuplicateErrorMessage(res.data.mergeAndDeleteDuplicate.error)
            
          }
      } catch (error) {
          setApiErrorMessage(error.message || "An unexpected error occurred");
      } finally {
        setIsLoading(false); 
      }
    }
    else if(capitalizedModuleName === "Company"){
      try {
        const res = await mutateData(MERGE_DELETE_DUPLICATE_COMPANIES, { input: extractedData });

        if(res.data.mergeAndDeleteDuplicateCompany.success){
          setDuplicateErrorMessage(null)
          setSavedToastMessage(true)
        }
        else if(res.data.mergeAndDeleteDuplicate.error){
          setDuplicateErrorMessage(res.data.mergeAndDeleteDuplicate.error)
        }
    } catch (error) {
        setApiErrorMessage(error.message || "An unexpected error occurred");
    } finally {
      setIsLoading(false); 
    }
    }

  };
  

  useEffect(() => { //if no type selected this will trigger error message 
    if (SelectedTypes.length > 0) {
      setErrorField(false);
    }
    else if(SelectedTypes.length === 0){
      setErrorField(true)
    }
  }, [SelectedTypes]);
  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    useTable({ columns, data });

  return (
    <div>
      <div>
        <h5 style={{ fontSize: "1.5rem" }}>Selected Duplicates</h5>
        <div
          style={{
            width: "100%",
            overflowX: "auto", // ✅ Enables horizontal scrolling
          }}
        >
          {selectedCells &&
          selectedCells.selectedData &&
          selectedCells.selectedData.length > 0 ? (
            <table
              {...getTableProps()}
              style={{
                width: "auto",
                maxWidth: "100%",
                tableLayout: "fixed",
                borderCollapse: "separate",
                borderSpacing: "0",
                borderRadius: "12px",
                overflow: "hidden",
                boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              <thead
                style={{
                  position: "sticky",
                  top: 0,
                  backgroundColor: "#fff",
                  zIndex: 2,
                }}
              >
                {headerGroups.map((headerGroup) => (
                  <tr
                    {...headerGroup.getHeaderGroupProps()}
                    key={headerGroup.id}
                  >
                    {headerGroup.headers.map((column, index, arr) => (
                      <th
                        {...column.getHeaderProps()}
                        key={column.id}
                        style={{
                          border: "1px solid  rgb(0,0,0,0.4)",
                          padding: "8px",
                          background: "#90C54B",
                          color: "white",
                          width: column.id === "type" ? "250px" : "200px",
                          minWidth: column.id === "type" ? "250px" : "200px",
                          maxWidth: column.id === "type" ? "250px" : "200px",
                          borderRadius:
                            index === 0
                              ? "12px 0 0 0"
                              : index === arr.length - 1
                              ? "0 12px 0 0"
                              : "0",
                        }}
                      >
                        {column.render("Header")}
                      </th>
                    ))}
                  </tr>
                ))}
              </thead>
              <tbody {...getTableBodyProps()}>
                {rows.map((row, rowIndex, rowArray) => {
                  prepareRow(row);
                  return (
                    <tr {...row.getRowProps()} key={row.id}>
                      {row.cells.map((cell, cellIndex, cellArray) => {
                        const isTypeColumn = cell.column.id === "type";
                        return (
                          <td
                            {...cell.getCellProps()}
                            key={cell.column.id}
                            style={{
                              width: isTypeColumn ? "250px" : "200px",
                              minWidth: isTypeColumn ? "250px" : "200px",
                              maxWidth: isTypeColumn ? "250px" : "200px",
                              border: "1px solid rgb(0,0,0,0.4)",
                              padding: "8px",
                              textAlign: "center",
                              whiteSpace: "nowrap",
                              overflow: "hidden",
                              textOverflow: "ellipsis",
                              borderRadius:
                                rowIndex === rowArray.length - 1 &&
                                cellIndex === 0
                                  ? "0 0 0 12px"
                                  : rowIndex === rowArray.length - 1 &&
                                    cellIndex === cellArray.length - 1
                                  ? "0 0 12px 0"
                                  : "0",
                            }}
                          >
                            {isTypeColumn ? (
                              <MultiSelectReusableField
                                options={options}
                                selectedValues={
                                  Array.isArray(row.original.type)
                                    ? row.original.type
                                    : []
                                }
                                handleTypeChange={handleTypeChange}
                                setErrorField={setErrorField}
                                errorfield={errorfield}
                                SelectedTypes={SelectedTypes}
                              />
                            ) : (
                              cell.render("Cell")
                            )}
                          </td>
                        );
                      })}
                    </tr>
                  );
                })}
              </tbody>
            </table>
          ) : (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                width: "100%",
                height: "62px",
                margin: "10px 0",
                textAlign: "center",
                backgroundColor: "#f8f9fa",
                border: "1px solid #ddd",
                borderRadius: "6px",
                padding: "5px",
                color: "#555",
                fontSize: "16px",
                fontWeight: "500",
                boxShadow: "2px 2px 10px rgba(0, 0, 0, 0.1)",
              }}
            >
              {debouncedSearchTerm && debouncedSearchTerm.length > 0
                ? "Please Select the Duplicate records from below table"
                : "Please search for duplicate records"}
            </div>
          )}
        </div>
        <button
          className="button-new positive"
          style={{
            marginTop: "10px",
            opacity:
              isLoading ||
             !(
      (
        selectedCells &&
        selectedCells.selectedData &&
        (
          (
            selectedCells.selectedData.some(function (item) {
              return item.columnId === "first name";
            }) &&
            selectedCells.selectedData.some(function (item) {
              return item.columnId === "last name";
            })
          ) ||
          selectedCells.selectedData.some(function (item) {
            return item.columnId === "company";
          })
        )
      ) ||
      (
        selectedCells &&
        selectedCells.isDeleted &&
        selectedCells.isDeleted.length > 0
      )
    )
                ? 0.6
                : 1.6,
          }}
          onClick={() => {
            if (
              SelectedTypes.length > 0 ||
              selectedCells.isDeleted.length > 0
            ) {
              setConfirmSave(true);
              setIsCrm(true);
            } else if (SelectedTypes.length === 0) {
              setErrorField(true);
            }
          }}
          //  disabled={(selectedCells && selectedCells.selectedData && selectedCells.selectedData.length  === 0 || selectedCells && selectedCells.isDeleted && selectedCells.isDeleted.length === 0)}
          disabled={
            isLoading ||
            !(
      (
        selectedCells &&
        selectedCells.selectedData &&
        (
          (
            selectedCells.selectedData.some(function (item) {
              return item.columnId === "first name";
            }) &&
            selectedCells.selectedData.some(function (item) {
              return item.columnId === "last name";
            })
          ) ||
          selectedCells.selectedData.some(function (item) {
            return item.columnId === "company";
          })
        )
      ) ||
      (
        selectedCells &&
        selectedCells.isDeleted &&
        selectedCells.isDeleted.length > 0
      )
    )
          }
        >
          Submit
        </button>
        {duplicateErrorMessage && (
          <div style={{ marginTop: "8px" }}>
            <Alert severity="error">
              {typeof duplicateErrorMessage === "string"
                ? duplicateErrorMessage
                : duplicateErrorMessage || duplicateErrorMessage.toString()}
            </Alert>
          </div>
        )}
        {apiErrorMessage && (
          <div style={{ marginTop: "8px" }}>
            <Alert severity="error">
              {typeof apiErrorMessage === "string"
                ? apiErrorMessage
                : apiErrorMessage.message || apiErrorMessage.toString()}
            </Alert>
          </div>
        )}
        {savedToastMessage && (
          <div style={{ marginTop: "8px" }}>
            <Alert severity="success">Saved.</Alert>
          </div>
        )}
      </div>
      {isLoading && <ReusableSpinner />}
      <div>
        {confirmSave && (
          <ConfirmationSaveDialog
            open={true}
            maxWidth="sm" // or "sm"
            fullWidth
            onClose={(result) => {
              if (result === "ok" && confirmSave) {
                handleSubmit();
              }
              setConfirmSave(false);
            }}
            isCrm={isCrm}
            setIsCrm={setIsCrm}
            missingFieldsMessage={missingFieldsMessage}
          />
        )}
      </div>
    </div>
  );
});

export default SelectedMergingTable;



